import { connect } from 'react-redux';
import moment from '~/Providers/Moment';

import Month from '~/Components/Pages/Calendar/MonthView/Month';
import { filterEventsByCalendarDisplay } from '~/Redux/Modules/Events/selectors';

const mapStateToProps = ({ Events, DateRange, CalendarAccounts }) => {
  const calendarDisplayOptions = {
    includeMonthView: false,
    includeDayView: true,
    includeWeekView: true,
  };
  const calendarMap = CalendarAccounts.calendarMap;
  const filteredEvents = filterEventsByCalendarDisplay(
    Events.formattedData,
    calendarDisplayOptions,
    calendarMap
  );
  return {
    events: filteredEvents,
    start: moment(DateRange.start),
    end: moment(DateRange.end),
  };
};

export default connect(mapStateToProps)(Month);
